<script>
import { certDetail, certList } from '@/api/demo/close'
import Image from '@/pages/demo/configuration/templateDialog/image.vue'
export default {
  name: 'PositionShow',
  components: { Image },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    //   当前选择的岗位
      position: {},
      positionId: '',
      dialogVisible: false
    }
  },
  watch: {
    value: {
      handler: function (val, oldVal) {
        this.positionId = val
        this.getPositionDetail()
      }
    }
  },
  created () {
    this.positionId = this.value
    this.getPositionDetail()
  },
  methods: {
    async getPositionDetail () {
      if (!this.value) {
        return
      }
      certDetail(this.value).then(res => {
        this.position = res
      })
    },
    selected (id) {
      this.positionId = id
      this.$emit('input', id)
      this.dialogVisible = false
    },
    handleClose (done) {
      done()
    },
    showSelector () {
      this.dialogVisible = true
    }
  }
}

</script>

<template>
  <div>
    <div class="position">
      <!--   显示已选择的岗位 包含头像和岗位名称 -->
      <img :src="position.icon" alt="">
      <span>{{position.name}}</span>
    </div>
  </div>
</template>

<style scoped>

.position{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.position img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
.position-item{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.position-item img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}
.selected{

  color: red;
}
</style>
